import Dropdown from '@components/Dropdown';
import PrismicLink from '@components/PrismicLink';
import { useContext } from 'react';
import { LayoutContext } from '@context/LayoutContext';

const PrismicSlice = () => {
  const { headerTop } = useContext(LayoutContext);

  return (
    <>
      {headerTop?.map((slice, index) => {
        switch (slice.slice_type) {
          case 'dropdown':
            return (
              <li
                key={`slice-${index}`}
                data-testid={`header-top-dropdown-${slice.primary.title}`}
              >
                <Dropdown
                  position="left"
                  label={
                    <span className="tw-text-nowrap">
                      {slice.primary.title}
                    </span>
                  }
                >
                  <ul className="tw-z-dropdown tw-min-w-[150px] tw-rounded-sm tw-bg-white tw-p-3 tw-pb-2 tw-shadow-dropdown">
                    {slice.items.map((item, index) => (
                      <li
                        key={index}
                        className="tw-whitespace-nowrap tw-px-1 tw-py-1 tw-text-left tw-font-semibold tw-text-black-1000 tw-transition-colors focus-within:tw-bg-beige-200 focus-within:tw-text-blue-600 hover:tw-bg-beige-200 hover:tw-text-blue-600"
                      >
                        <PrismicLink
                          className="tw-block"
                          link={item.link}
                          trackingId={item.trackingid_dropdown_link}
                        >
                          {item.title}
                        </PrismicLink>
                      </li>
                    ))}
                  </ul>
                </Dropdown>
              </li>
            );
          case 'link':
            return slice.items.map((link, index) => (
              <li key={`slice-${index}`} className="tw-relative tw-text-nowrap">
                <PrismicLink
                  link={link.link}
                  trackingId={link.trackingid_header_top_link}
                >
                  {link.name}
                </PrismicLink>
              </li>
            ));
          default:
            return null;
        }
      })}
    </>
  );
};

export default PrismicSlice;
